export const GET_LIST_QUIZZES = '/quiz/list';
export const GET_QUIZ_INFO = '/quiz/getById';
export const CREATE_QUIZ = '/quiz/create';
export const UPDATE_QUIZ = '/quiz/update';
export const DELETE_QUIZ = '/quiz/delete';
export const UPDATE_QUIZ_QUESTIONS = '/quiz/update-question';
